import { Button, ButtonVariant, HorizontalSpacer, Label, Layout, LayoutProps, Panel } from "@mcleod/components";
import { Alignment, AuthType, getUnauthSettings, HorizontalAlignment, Navigation, WindowTitle } from "@mcleod/core";
import { McLeodMainPage } from "../McLeodMainPage";
import { ModelUserHomePage, RowUserHomePage } from "../models/ModelUserHomePage";

export class Home extends Layout {
  buttonConfig: Button;
  layout: Layout;

  constructor(props: LayoutProps) {
    super({
        auth: AuthType.ANY,
        needsServerLayout: false,
        title: "PowerBroker Home",
        ...props });
}

override onLoad() {
    this.loadUserHomePage();
}

  loadUserHomePage() {
    new ModelUserHomePage().searchSingle().then((row: RowUserHomePage) => {
      const def = row?.get("definition");
      const homePage = row?.get("home_page");
      if (row == null && def == null && homePage == null)
        McLeodMainPage.getInstance().header.showMenu();
      else if (homePage != null)
        this.showHomePage(homePage);

      else if (def != null) {
        this.initializeLayout();
        this.layout.displayLayout(row.get("definition"));
      }
      if (row?.getBoolean("allow_configure"))
        this.addConfigButton();
    });
  }

  private showHomePage(page: string) {
    const layout = Layout.getLayout(page);
    layout.addLayoutLoadListener(() => {
      if (layout.title != null) {
        const settings = getUnauthSettings()?.company_settings;
        WindowTitle.set(layout.title + " - " + settings.name);
      }
    })
    this.padding = 24;
    this.add(layout);
  }

  private addConfigButton() {
    this.buttonConfig = new Button({
      imageName: "settings",
      variant: ButtonVariant.round,
      color: "subtle.light",
      tooltip: "Choose what appears on your home page",
      tooltipPosition: Alignment.LEFT
    });
    this.buttonConfig.addClickListener(() => this.configureHomePage());
    this.initializeLayout();
    if (this.contains(this.layout)) {
      this.insert(this.buttonConfig, 0);
      this.insert(new HorizontalSpacer(), 0);
    }
    else
      this.add(new HorizontalSpacer(), this.buttonConfig, this.layout);
  }

  private initializeLayout() {
    this.layout = new Layout({ minHeight: "100%" });
    this.add(this.layout);
  }

  private showGetStarted() {
    const panel = new Panel({ fillRow: true, align: HorizontalAlignment.CENTER });
    const label = new Label({
      caption: "You haven't set up anything to be displayed on your home page.  Click the gear icon to get started.",
      color: "subtle.darker",
      align: HorizontalAlignment.CENTER,
      width: 300
    });
    panel.add(label);
    this.layout.add(panel);
    this.buttonConfig.showTooltip("Click here to get started!", { position: Alignment.LEFT, shaking: true, timeout: 5000 });
  }

  configureHomePage() {
    Navigation.navigateTo("common/home/HomePageEditor")
  }

  getRouterProps() {
    return { padding: 0 };
  }
}
